import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href", "title"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_image = _resolveComponent("base-image")

  return (_openBlock(), _createElementBlock("a", {
    href: $props.url,
    title: $props.name
  }, [
    _createVNode(_component_base_image, {
      src: $props.imageUrl,
      width: $props.size,
      height: $props.size,
      alt: $props.name,
      class: "_rounded--common _bxsh--base"
    }, null, 8 /* PROPS */, ["src", "width", "height", "alt"])
  ], 8 /* PROPS */, _hoisted_1))
}